import React, { useState, useEffect } from 'react'
import { refreshProduct } from 'src/api/shopify-client-api'
import { useStore } from 'src/state'
import Link from 'src/components/link'
import Card from 'src/components/card'
import Button from 'src/components/button'
import Picture from 'src/components/picture'

const ProductCard = (p) => {
  const [product, setProduct] = useState(p)
  const { title, prettyPrice, shopUrl, image, hasInventory, isRefreshed } =
    product
  const [hasFetched, setHasFetched] = useState(false)
  const {
    setFormOverlayId,
    showFormOverlay,
    setNotifyMeProductHandle,
    general: { soldOutText, notifyMeFormId, notifyMeText, comingSoonText },
  } = useStore()

  useEffect(() => {
    async function fetchData() {
      const refreshedProduct = await refreshProduct(product)
      setProduct(refreshedProduct)
    }
    !hasFetched && fetchData()
    setHasFetched(true)
  }, [product, hasFetched])

  return (
    <Card className="product-card">
      <Link
        to={shopUrl}
        className="card-content"
        onClick={(event) => {
          !hasInventory && p.metafields.isComingSoon && event.preventDefault()
        }}
      >
        <Picture
          defaultWidth={750}
          className="product-image"
          image={image && image.src}
          cover
          fitWidth
        />
        <div className="background-gradient" />
        <div className="card-details">
          <p className="card-title title">{title}</p>
          <p className="card-subtitle price">{prettyPrice}</p>
        </div>
        {!hasInventory && isRefreshed && (
          <div className="sold-out-overlay">
            <h3 className="centered">
              {p.metafields.isComingSoon ? comingSoonText : soldOutText}
            </h3>
            <Button
              onClick={(event) => {
                setFormOverlayId(notifyMeFormId)
                setNotifyMeProductHandle(product.handle)
                showFormOverlay()
                event.preventDefault()
              }}
              className="notify-me-btn"
            >
              <p className="action-text centered">{notifyMeText}</p>
            </Button>
          </div>
        )}
      </Link>
    </Card>
  )
}

export default ProductCard
